import React, { useEffect } from 'react';
import MultistepWizard from '../multiStepWizard/MultistepWizard';
import PatientDetails from './SubPageWidgets/PatientDetails';
import OriginDestination from './SubPageWidgets/OriginDestination';
import PickDropTime from './SubPageWidgets/PickDropTime';
import Allergies from './SubPageWidgets/Allergies';
import Conditions from './SubPageWidgets/Conditions';
import Observations from './SubPageWidgets/Observations';
import Medications from './SubPageWidgets/Medications';
import ReviewAndSubmit from './SubPageWidgets/ReviewAndSubmit';
import { showNavbar } from '../../store/modules/appStateSlice';
import { useDispatch } from 'react-redux';
import api from '../../store/api';
import { useBeforeunload } from 'react-beforeunload';
import { Prompt } from 'react-router-dom';
import { useHistory } from "react-router-dom";

const compMap = {  
    "Patient Details": PatientDetails,
    "Origin & Destination": OriginDestination,
    "Pickup/Dropoff Time": PickDropTime,
    "Allergies": Allergies,
    "Conditions": Conditions,
    "Observations": Observations,
    "Medications": Medications,
    "Review & Submit": ReviewAndSubmit,
};

const AddBooking = () => {
    const history = useHistory();
    const [isBookingCompletedOrCanceled, setIsBookingCanceledOrCanceled] = React.useState(false);
    const stepState = React.useState(0);
    const formState = React.useState({});
    const saveChangesState = React.useState(() => () => null);
    const dispatch = useDispatch();

    const getLocationsData = async (): Promise<void> => {
        try {

            const res = await api.getCustomerLocations('');
            localStorage.setItem('customerLocations', JSON.stringify(res.data.model));
        }
        catch
        {

        }
    }

    const getRecentlyUsedLocations = async (): Promise<void> => {
        try {

            const res = await api.getRecentlyUsedLocations('');
            localStorage.setItem('recentLocations', JSON.stringify(res.data.model));
        }
        catch
        {

        }
    }

    const getMedicationRoutes = async (): Promise<void> => {
        try {
            const res = await api.getRoutes('');
            localStorage.setItem('medicationRoutes', JSON.stringify(res.data.model));
        }
        catch
        {

        }
    }

    useBeforeunload(() => {
        if (stepState[0] > 0 && !isBookingCompletedOrCanceled) {
            var confirmationMessage = 'Are you sure you wish to leave this page? Any changes you will be lost if you leave without saving them. '
                + 'Please use the on page nagivation if you wish to continue with this booking.';         
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        }
        else {
            return undefined;
        }
    });
    useEffect(() => {
        if (isBookingCompletedOrCanceled) {
            history.push('/');
        }
    }, [isBookingCompletedOrCanceled]);

    const cancelBooking = (): void => {
        setIsBookingCanceledOrCanceled(true);       
    }

    useEffect(() => {       
        dispatch(showNavbar(false));
        getLocationsData();
        getRecentlyUsedLocations();
        getMedicationRoutes();
    }, [])

    return (
        <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
            <Prompt
                when={stepState[0] > 0 && !isBookingCompletedOrCanceled}
                message={(_nextLocation, action) => {
                 
                    if (_nextLocation.state) {
                        return true;
                    }
                    return JSON.stringify({
                        action,
                        message: 'Are you sure you wish to leave this page? Any changes you will be lost if you leave without saving them. Please use the on page nagivation if you wish to continue with this booking.'
                    })
                }}
            />
            <MultistepWizard
                formState={formState}
                stepState={stepState}
                components={compMap}
                isEdit={false}
                saveChangesState={saveChangesState}
                onCancel={cancelBooking}
                existsOnPlanner={false}
            />
        </div>
    );
}
export default AddBooking;